import { Component } from '@angular/core';


@Component({
	selector: 'devo-pipeline-tab-1-part',
	standalone: true,
	templateUrl: './devo-pipeline-tab-1.part.html',
	styleUrls: [`./devo-pipeline-tab-1.part.scss`],
})
export class DevoPipelineTab1Part {
}
